module.exports = __webpack_public_path__ + "static/media/mention.3f30363d.svg";